import clx from 'classnames';
import Link from 'next/link';
import { CTA_TOOL_VARIANT_ENUM, CTAToolType } from './type';

export const CTA_TOOL_CLASS_NAME = `
  flex items-center gap-2 py-1 px-2
  rounded-full border-2 border-solid
  text-neutral-50 sm-bold-caps whitespace-nowrap
  transition-colors duration-quicker ease-out
`;

export const CTA_TOOL_VARIANT_CLASSNAME: Record<CTA_TOOL_VARIANT_ENUM, string> = {
  [CTA_TOOL_VARIANT_ENUM.ACTION]: `
    bg-neutral-700 border-neutral-700
    hover:bg-neutral-400 focus:bg-neutral-600
    hover:border-neutral-400 focus:border-neutral-600
  `,
  [CTA_TOOL_VARIANT_ENUM.INFO]: `
    bg-mercury-900 border-mercury-900
    hover:bg-mercury-700 focus:bg-mercury-600
    hover:border-mercury-700 focus:border-mercury-600
  `,
};

const CtaTool = ({ children, onClick, href, icon, variant = CTA_TOOL_VARIANT_ENUM.ACTION }: CTAToolType) => {
  if (onClick) {
    return (
      <button className={clx(CTA_TOOL_CLASS_NAME, CTA_TOOL_VARIANT_CLASSNAME[variant])} onClick={onClick} type="button">
        {icon && <i className={icon} />}
        {children}
      </button>
    );
  }
  if (href) {
    return (
      <Link className={clx(CTA_TOOL_CLASS_NAME, CTA_TOOL_VARIANT_CLASSNAME[variant])} href={href}>
        {icon && <i className={icon} />}
        {children}
      </Link>
    );
  }

  return null;
};

export default CtaTool;
export type { CTAToolType };
